import { useParams, Navigate } from "react-router-dom";
import { getService } from "@/data/services";
import { getLocale } from "@/data/locales";
import { getSecteur } from "@/data/secteurs";
import ServicePage from "./ServicePage";
import LocalPage from "./LocalPage";
import SectorPage from "./SectorPage";

// Single dynamic resolver for root-level slugs (services + geographic + sector landing pages).
export default function SlugResolver() {
  const { slug } = useParams();
  if (getService(slug)) return <ServicePage />;
  if (getSecteur(slug)) return <SectorPage />;
  if (getLocale(slug)) return <LocalPage />;
  return <Navigate to="/404" replace />;
}
